/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   MapBox Module Selectors
 */

import type { MainMapDataTypes, MainMapMetaTypes, State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectMainMapData = (state: State) => state.mainMap.data
export const selectMainMapMeta = (state: State) => state.mainMap.meta

export const selectBearing = (state: MainMapDataTypes) => state.bearing
export const selectLatitude = (state: MainMapDataTypes) => state.latitude
export const selectLongitude = (state: MainMapDataTypes) => state.longitude
export const selectCenter = (state: MainMapDataTypes) =>
  ({
    lat: state.latitude,
    lng: state.longitude,
  }) as const
export const selectPitch = (state: MainMapDataTypes) => state.pitch
export const selectZoom = (state: MainMapDataTypes) => state.zoom
export const selectDimensions = (state: MainMapDataTypes) => ({
  width: state.width,
  height: state.height,
})
export const selectFrozenZoom = (state: MainMapMetaTypes) => state.frozenZoom
export const selectReady = (state: MainMapMetaTypes) => state.ready
export const selectMounted = (state: MainMapMetaTypes) => state.mounted
export const selectUnsynced = (state: MainMapMetaTypes) => state.unsynced
export const selectSyncDisabled = (state: MainMapMetaTypes) => state.syncDisabled
export const selectSyncOnMove = (state: MainMapMetaTypes) => state.syncOnMove
export const selectVisible = (state: MainMapMetaTypes) => state.visible
export const selectBox = (state: MainMapMetaTypes) => state.box

export const selectMapBearing = compose(selectBearing, selectMainMapData)
export const selectMapCenter = compose(selectCenter, selectMainMapData)
export const selectMapLatitude = compose(selectLatitude, selectMainMapData)
export const selectMapLongitude = compose(selectLongitude, selectMainMapData)
export const selectMapPitch = compose(selectPitch, selectMainMapData)
export const selectMapZoom = compose(selectZoom, selectMainMapData)
export const selectMapDimensions = compose(selectDimensions, selectMainMapData)
export const selectMapFrozenZoom = compose(selectFrozenZoom, selectMainMapMeta)
export const selectMapReady = compose(selectReady, selectMainMapMeta)
export const selectMapUnsynced = compose(selectUnsynced, selectMainMapMeta)
export const selectMapSyncDisabled = compose(selectSyncDisabled, selectMainMapMeta)
export const selectMapSyncOnMove = compose(selectSyncOnMove, selectMainMapMeta)
export const selectMapVisible = compose(selectVisible, selectMainMapMeta)
export const selectMapBox = compose(selectBox, selectMainMapMeta)
export const selectMapMounted = compose(selectMounted, selectMainMapMeta)
